<template>
  <form-autocomplete :label="label"
                     :data="search"
                     v-model="val"
                     :disabled="disabled"
                     :custom-not-found-text="customNotFoundText"
                     :selected="selected">
  </form-autocomplete>
</template>

<script>
  export default {
    props: {
        label: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        value: null,
        initials: {
            type: null,
            default: null
        },
        canAddExternal: {
            type: Boolean,
            default: true
        },
        customNotFoundText: {
        type: null,
        default: false
      },
    },
    data() {
      return {
        val: '',
        extractedLabel: this.label || this.$t('interface.chooseSender')
      }
    },
    methods: {
      search(q) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('Reference/getSenders', q).then(data => {
            let list = data.map((item) => {
              return {
                key: JSON.stringify({
                  type: item.type,
                  object_id: item.id
                }),
                value: item.name
              }
            })

            if (this.canAddExternal) {
              list.unshift({
                key: JSON.stringify({
                  type: 'external',
                  name: q
                }),
                value: `${this.$t('interface.addExternalOrganization')} "${q}"`
              })
            }

            resolve(list)
          }).catch(error => reject(error))
        })
      }
    },
    computed: {
      selected() {
        if (this.value && this.initials) {
          return {
            key: this.value,
            value: this.initials
          }
        } else return false
      }
    },
    watch: {
      val(value) {
        this.$emit('input', value)
      }
    }
  }
</script>
